import { supabase } from "@/integrations/supabase/client";
import { getDeviceId } from "./preAuthMetrics";

export type OnboardingEventType =
  | "generate_metrics_click"
  | "metrics_generated"
  | "sign_in_click"
  | "setup_later_click"
  | "captcha_failed"
  | "signup_email"
  | "signup_google"
  | "signup_apple"
  | "referral_code_used"
  | "username_created"
  | "landing_variant_assigned"
  | "app_store_click";

interface TrackOnboardingEventOptions {
  eventType: OnboardingEventType;
  metadata?: Record<string, any>;
}

/**
 * Track an onboarding event for analytics
 * Works for both anonymous and authenticated users
 */
export async function trackOnboardingEvent({
  eventType,
  metadata = {},
}: TrackOnboardingEventOptions): Promise<void> {
  try {
    const deviceId = getDeviceId();

    // Call the database function to track the event
    // Using 'any' cast because the RPC function is newly created
    const { error } = await (supabase.rpc as any)("track_onboarding_event", {
      p_event_type: eventType,
      p_device_id: deviceId,
      p_metadata: metadata,
    });

    if (error) {
      console.error("[OnboardingAnalytics] Error tracking event:", error);
    } else {
      console.log("[OnboardingAnalytics] Event tracked:", eventType, metadata);
    }
  } catch (error) {
    // Don't let analytics errors break the user experience
    console.error("[OnboardingAnalytics] Failed to track event:", error);
  }
}

/**
 * Track an app store download button click
 * Records which store and which page/source the click originated from
 */
export function trackStoreClick(
  store: "apple" | "google",
  source: string
): void {
  trackOnboardingEvent({
    eventType: "app_store_click",
    metadata: { store, source },
  });
}
